(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["automne-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAbSlider() {
      var el = document.querySelector('.ab-slider');
      if (!el || el.classList.contains('is-initialized')) return;
      if (typeof Splide === 'undefined') {
        if (window.loadSplide && !el.dataset.splideRequested) {
          el.dataset.splideRequested = '1';
          window.loadSplide().then(initAbSlider);
        } else if (!window.loadSplide) {
          setTimeout(initAbSlider, 200);
        }
        return;
      }
      var splide = new Splide(el, {
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: true,
        autoplay: 'pause',
        interval: 5000,
        gap: 0,
        mediaQuery: 'min',
        breakpoints: {
          750: { destroy: true },
        },
      }).mount();
      /* Perf : le 1er slide reste statique tant que l'internaute n'a pas interagi (LCP / Speed Index) */
      var started = false;
      function startAutoplay() {
        if (started) return;
        started = true;
        ['touchstart', 'pointerdown', 'wheel', 'keydown', 'scroll'].forEach(function (ev) { window.removeEventListener(ev, startAutoplay, { passive: true }); });
        try { splide.Components.Autoplay.play(); } catch (e) {}
      }
      ['touchstart', 'pointerdown', 'wheel', 'keydown', 'scroll'].forEach(function (ev) { window.addEventListener(ev, startAutoplay, { passive: true, once: true }); });
    }
    function initAbAdd() {
      var btn = document.querySelector('.ab-btn[data-ab-add]');
      if (!btn) return;
      var ids = (btn.getAttribute('data-ab-add') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy');
        var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
        var drawer = document.querySelector('cart-drawer');
        var sectionId = drawer && drawer.dataset ? drawer.dataset.sectionId : null;
        var body = { items: items, sections_url: window.location.pathname };
        if (sectionId) body.sections = sectionId;
        var label = btn.querySelector('span.ab-btn__txt');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.status) { window.location.href = '/cart'; return; }
            if (!drawer) { window.location.href = '/cart'; return; }
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var ev = new Event('cart:updated', { bubbles: true });
                ev.detail = { resource: cart, data: { source: 'automne-banner', sections: data.sections, itemCount: cart.item_count } };
                document.dispatchEvent(ev);
                document.dispatchEvent(new Event('cart:open'));
                if (label) { var t = label.textContent; label.textContent = 'Ajouté au panier ✓'; setTimeout(function () { label.textContent = t; }, 1800); }
                btn.classList.remove('is-busy');
              });
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAbSlider(); initAbAdd(); });
    } else {
      initAbSlider(); initAbAdd();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jojoba-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initJbSlider() {
      var el = document.querySelector('.jb-slider');
      if (!el || el.classList.contains('is-initialized')) return;
      if (typeof Splide === 'undefined') {
        setTimeout(initJbSlider, 200);
        return;
      }
      new Splide(el, {
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: true,
        autoplay: true,
        interval: 5000,
        gap: 0,
        mediaQuery: 'min',
        breakpoints: {
          750: { destroy: true },
        },
      }).mount();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initJbSlider);
    } else {
      initJbSlider();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rentree-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRbSlider() {
      var el = document.querySelector('.rb-slider');
      if (!el || el.classList.contains('is-initialized')) return;
      if (typeof Splide === 'undefined') {
        setTimeout(initRbSlider, 200);
        return;
      }
      new Splide(el, {
        type: 'loop',
        perPage: 1,
        arrows: false,
        pagination: true,
        autoplay: true,
        interval: 5000,
        gap: 0,
        mediaQuery: 'min',
        breakpoints: {
          750: { destroy: true },
        },
      }).mount();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRbSlider);
    } else {
      initRbSlider();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiki-blog-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid=document.getElementById('wbxGrid');
  if(!grid) return;
  var search=document.getElementById('wbxSearch');
  var empty=document.getElementById('wbxEmpty');
  var filters=document.getElementById('wbxFilters');
  var items=Array.prototype.slice.call(grid.querySelectorAll('.wbx__item'));
  var state={q:'',tag:''};
  function norm(v){return (v||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');}
  function apply(){
    var q=norm(state.q.trim()),shown=0;
    items.forEach(function(it){
      var name=norm(it.getAttribute('data-title'));
      var tags=it.getAttribute('data-tags')||'';
      var okQ=!q||name.indexOf(q)>-1;
      var okT=!state.tag||('|'+tags+'|').indexOf('|'+state.tag+'|')>-1;
      var ok=okQ&&okT; it.hidden=!ok; if(ok)shown++;
    });
    if(empty) empty.hidden=shown!==0;
  }
  if(search) search.addEventListener('input',function(){state.q=search.value;apply();});
  if(filters){
    filters.addEventListener('click',function(e){
      var b=e.target.closest('.wbx__chip'); if(!b) return;
      state.tag=b.getAttribute('data-value');
      Array.prototype.forEach.call(filters.querySelectorAll('.wbx__chip'),function(x){x.classList.toggle('is-active',x===b);});
      apply();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiki-plante-fiche"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rail=document.getElementById('wktRail');
  if(!rail) return;
  var svg=document.getElementById('wktSvg');
  var pathBg=document.getElementById('wktPathBg'), pathFg=document.getElementById('wktPathFg');
  var pins=document.getElementById('wktPins'), marker=document.getElementById('wktMarker');
  var trail=document.getElementById('wktTrail');
  var stops=Array.prototype.slice.call(document.querySelectorAll('.wkt__stop'));
  var NS='http://www.w3.org/2000/svg', W=130, amp=36, len=0;

  function buildPath(){
    var H=rail.offsetHeight;
    // Largeur réelle du rail (130px desktop, 64px mobile) — sinon le chemin déborde sur le contenu.
    W=rail.offsetWidth||130; amp=W*0.28;
    svg.setAttribute('width',W); svg.setAttribute('height',H); svg.setAttribute('viewBox','0 0 '+W+' '+H);
    var d='M '+(W/2)+' 0';
    for(var y=0;y<=H;y+=20){ var x=W/2 + Math.sin(y/150)*amp; d+=' L '+x.toFixed(1)+' '+y; }
    pathBg.setAttribute('d',d); pathFg.setAttribute('d',d);
    len=pathFg.getTotalLength();
    pathFg.style.strokeDasharray=len; pathFg.style.strokeDashoffset=len;
    pins.innerHTML='';
    stops.forEach(function(sec,i){
      var t=stops.length>1 ? i/(stops.length-1) : 0;
      var pt=pathFg.getPointAtLength(len*(0.01+t*0.97));
      var last=(i===stops.length-1) && sec.classList.contains('wkt__stop--dest');
      var g=document.createElementNS(NS,'g');
      var c=document.createElementNS(NS,'circle');
      c.setAttribute('cx',pt.x); c.setAttribute('cy',pt.y); c.setAttribute('r',last?15:13);
      c.setAttribute('fill',last?'#2C5638':'#fff'); c.setAttribute('stroke','#4B7A54'); c.setAttribute('stroke-width','3');
      var tx=document.createElementNS(NS,'text');
      tx.setAttribute('x',pt.x); tx.setAttribute('y',pt.y+(last?5:4)); tx.setAttribute('text-anchor','middle');
      tx.setAttribute('font-size',last?'14':'12'); tx.setAttribute('font-weight','700');
      tx.setAttribute('fill',last?'#fff':'#2C5638'); tx.setAttribute('font-family','Inter,sans-serif');
      tx.textContent=last?'★':(i+1);
      g.appendChild(c); g.appendChild(tx); pins.appendChild(g);
    });
  }
  function upd(){
    var top=trail.offsetTop, h=trail.offsetHeight;
    var p=(window.scrollY+window.innerHeight*0.5-top)/h; p=Math.min(Math.max(p,0),1);
    pathFg.style.strokeDashoffset=len*(1-p);
    var pt=pathFg.getPointAtLength(len*p);
    marker.style.left=pt.x+'px'; marker.style.top=pt.y+'px';
    var trig=window.scrollY+window.innerHeight*0.78;
    stops.forEach(function(sec){ if(sec.getBoundingClientRect().top+window.scrollY<trig) sec.classList.add('in'); });
  }
  function boot(){ buildPath(); upd(); }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',function(){ buildPath(); upd(); });
  if(document.readyState==='complete') boot(); else window.addEventListener('load',boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiki-plantes-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid = document.getElementById('wkxGrid');
  if(!grid) return;
  var search = document.getElementById('wkxSearch');
  var empty = document.getElementById('wkxEmpty');
  var filters = document.getElementById('wkxFilters');
  var items = Array.prototype.slice.call(grid.querySelectorAll('.wkx__item'));
  var state = { q:'', usage:'', prop:'' };

  function norm(v){ return (v||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");  }

  function apply(){
    var q = norm(state.q.trim());
    var shown = 0;
    items.forEach(function(it){
      var name = norm(it.getAttribute('data-name'));
      var latin = norm(it.getAttribute('data-latin'));
      var prop = it.getAttribute('data-prop') || '';
      var usage = it.getAttribute('data-usage') || '';
      var okQ = !q || name.indexOf(q) > -1 || latin.indexOf(q) > -1;
      var okU = !state.usage || ('|'+usage+'|').indexOf('|'+state.usage+'|') > -1;
      var okP = !state.prop || ('|'+prop+'|').indexOf('|'+state.prop+'|') > -1;
      var ok = okQ && okU && okP;
      it.hidden = !ok;
      if(ok) shown++;
    });
    if(empty) empty.hidden = shown !== 0;
  }

  if(search) search.addEventListener('input', function(){ state.q = search.value; apply(); });

  if(filters){
    filters.addEventListener('click', function(e){
      var btn = e.target.closest('.wkx__chip');
      if(!btn) return;
      var type = btn.getAttribute('data-filter');
      state[type] = btn.getAttribute('data-value');
      var group = btn.parentNode.querySelectorAll('.wkx__chip');
      Array.prototype.forEach.call(group, function(b){ b.classList.toggle('is-active', b === btn); });
      apply();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
